import React, { useState } from "react";


const FAQSection = () => {
  const faqs = [
    {
      question: "How long does it take to complete a home interior project?",
      answer: "The duration depends on the size of your home and the complexity of the design. Typically, projects take 6-12 weeks from design to execution.",
    },
    {
      question:
        "HCan I customize my interior design plan?",
      answer: "Absolutely! Our designs are fully customizable to match your preferences, needs, and budget.",
    },
    {
      question: "Do you offer furniture as part of the interior design package?",
      answer: "Yes, we provide furniture solutions tailored to your interior design theme, ensuring a cohesive look.",
    },
    {
      question:
        "What is included in your home interior services?",
      answer:
        "Our services include layout planning, material selection, furniture design, lighting, and complete project execution.",
    },
    {
      question: "Can you work within my budget?",
      answer:
        "Yes, we offer flexible packages to ensure your dream space is created without exceeding your budget.",
    },
    {
      question: "Do you handle office and shop interiors as well?",
      answer:
        "Yes, we specialize in designing offices, shops, and homes with innovative and functional layouts.",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="container">
        <h2 className="faq-title">FAQs</h2>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${activeIndex === index ? "active" : ""}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                <span>{index + 1}. {faq.question}</span>
                <span className="faq-icon">{activeIndex === index ? "-" : "+"}</span>
              </div>
              {activeIndex === index && (
                <div className="faq-answer">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
